<input global-ui-input [disabled]="disabled" (keypress)="keyPress($event)" #input [placeholder]="'jobboard::index.enter' | translate" [value]="this.value" (change)="change($event)"  (focus)="focusin()" (blur)="focusout()" />
